/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youcanaddimageslaterfromtheeventdetailspage9Inputs */

const en_youcanaddimageslaterfromtheeventdetailspage9 = /** @type {(inputs: Youcanaddimageslaterfromtheeventdetailspage9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can add images later from the event details page.`)
};

const de_youcanaddimageslaterfromtheeventdetailspage9 = /** @type {(inputs: Youcanaddimageslaterfromtheeventdetailspage9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder kannst du später auf der Seite des Events hinzufügen.`)
};

/**
* | output |
* | --- |
* | "You can add images later from the event details page." |
*
* @param {Youcanaddimageslaterfromtheeventdetailspage9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const youcanaddimageslaterfromtheeventdetailspage9 = /** @type {((inputs?: Youcanaddimageslaterfromtheeventdetailspage9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youcanaddimageslaterfromtheeventdetailspage9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youcanaddimageslaterfromtheeventdetailspage9(inputs)
	return de_youcanaddimageslaterfromtheeventdetailspage9(inputs)
});
export { youcanaddimageslaterfromtheeventdetailspage9 as "youCanAddImagesLaterFromTheEventDetailsPage" }